/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateAccoladeOutputBody,
  CreateAccoladeRequest,
  ErrorModel,
  GetAccoladeOutputBody,
  ListAccoladesOutputBody,
  ReplaceAccoladeRequest,
  UpdateAccoladeOutputBody,
} from '../models/index';
import {
    CreateAccoladeOutputBodyFromJSON,
    CreateAccoladeOutputBodyToJSON,
    CreateAccoladeRequestFromJSON,
    CreateAccoladeRequestToJSON,
    ErrorModelFromJSON,
    ErrorModelToJSON,
    GetAccoladeOutputBodyFromJSON,
    GetAccoladeOutputBodyToJSON,
    ListAccoladesOutputBodyFromJSON,
    ListAccoladesOutputBodyToJSON,
    ReplaceAccoladeRequestFromJSON,
    ReplaceAccoladeRequestToJSON,
    UpdateAccoladeOutputBodyFromJSON,
    UpdateAccoladeOutputBodyToJSON,
} from '../models/index';

export interface CreateAccoladeOperationRequest {
    createAccoladeRequest: Omit<CreateAccoladeRequest, '$schema'>;
}

export interface DeleteAccoladeRequest {
    accoladeID: number;
}

export interface GetAccoladeRequest {
    accoladeID: number;
}

export interface ListAccoladesRequest {
    f?: string;
    p?: string;
    s?: string;
}

export interface ReplaceAccoladeOperationRequest {
    accoladeID: number;
    replaceAccoladeRequest: Omit<ReplaceAccoladeRequest, '$schema'>;
}

/**
 * 
 */
export class AccoladesApi extends runtime.BaseAPI {

    /**
     * Creates request options for createAccolade without sending the request
     */
    async createAccoladeRequestOpts(requestParameters: CreateAccoladeOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createAccoladeRequest'] == null) {
            throw new runtime.RequiredError(
                'createAccoladeRequest',
                'Required parameter "createAccoladeRequest" was null or undefined when calling createAccolade().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accolades`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAccoladeRequestToJSON(requestParameters['createAccoladeRequest']),
        };
    }

    /**
     * Create an accolade
     * Create Accolade
     */
    async createAccoladeRaw(requestParameters: CreateAccoladeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateAccoladeOutputBody>> {
        const requestOptions = await this.createAccoladeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateAccoladeOutputBodyFromJSON(jsonValue));
    }

    /**
     * Create an accolade
     * Create Accolade
     */
    async createAccolade(requestParameters: CreateAccoladeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateAccoladeOutputBody> {
        const response = await this.createAccoladeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteAccolade without sending the request
     */
    async deleteAccoladeRequestOpts(requestParameters: DeleteAccoladeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accoladeID'] == null) {
            throw new runtime.RequiredError(
                'accoladeID',
                'Required parameter "accoladeID" was null or undefined when calling deleteAccolade().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accolades/{accoladeID}`;
        urlPath = urlPath.replace(`{${"accoladeID"}}`, encodeURIComponent(String(requestParameters['accoladeID'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete an accolade
     * Delete Accolade
     */
    async deleteAccoladeRaw(requestParameters: DeleteAccoladeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteAccoladeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an accolade
     * Delete Accolade
     */
    async deleteAccolade(requestParameters: DeleteAccoladeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAccoladeRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAccolade without sending the request
     */
    async getAccoladeRequestOpts(requestParameters: GetAccoladeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accoladeID'] == null) {
            throw new runtime.RequiredError(
                'accoladeID',
                'Required parameter "accoladeID" was null or undefined when calling getAccolade().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accolades/{accoladeID}`;
        urlPath = urlPath.replace(`{${"accoladeID"}}`, encodeURIComponent(String(requestParameters['accoladeID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get an accolade
     * Get Accolade
     */
    async getAccoladeRaw(requestParameters: GetAccoladeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccoladeOutputBody>> {
        const requestOptions = await this.getAccoladeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccoladeOutputBodyFromJSON(jsonValue));
    }

    /**
     * Get an accolade
     * Get Accolade
     */
    async getAccolade(requestParameters: GetAccoladeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccoladeOutputBody> {
        const response = await this.getAccoladeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listAccolades without sending the request
     */
    async listAccoladesRequestOpts(requestParameters: ListAccoladesRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['f'] != null) {
            queryParameters['f'] = requestParameters['f'];
        }

        if (requestParameters['p'] != null) {
            queryParameters['p'] = requestParameters['p'];
        }

        if (requestParameters['s'] != null) {
            queryParameters['s'] = requestParameters['s'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accolades`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List all accolades
     * List Accolades
     */
    async listAccoladesRaw(requestParameters: ListAccoladesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAccoladesOutputBody>> {
        const requestOptions = await this.listAccoladesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAccoladesOutputBodyFromJSON(jsonValue));
    }

    /**
     * List all accolades
     * List Accolades
     */
    async listAccolades(requestParameters: ListAccoladesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAccoladesOutputBody> {
        const response = await this.listAccoladesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for replaceAccolade without sending the request
     */
    async replaceAccoladeRequestOpts(requestParameters: ReplaceAccoladeOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accoladeID'] == null) {
            throw new runtime.RequiredError(
                'accoladeID',
                'Required parameter "accoladeID" was null or undefined when calling replaceAccolade().'
            );
        }

        if (requestParameters['replaceAccoladeRequest'] == null) {
            throw new runtime.RequiredError(
                'replaceAccoladeRequest',
                'Required parameter "replaceAccoladeRequest" was null or undefined when calling replaceAccolade().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accolades/{accoladeID}`;
        urlPath = urlPath.replace(`{${"accoladeID"}}`, encodeURIComponent(String(requestParameters['accoladeID'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReplaceAccoladeRequestToJSON(requestParameters['replaceAccoladeRequest']),
        };
    }

    /**
     * Replace an accolade
     * Replace Accolade
     */
    async replaceAccoladeRaw(requestParameters: ReplaceAccoladeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateAccoladeOutputBody>> {
        const requestOptions = await this.replaceAccoladeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateAccoladeOutputBodyFromJSON(jsonValue));
    }

    /**
     * Replace an accolade
     * Replace Accolade
     */
    async replaceAccolade(requestParameters: ReplaceAccoladeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateAccoladeOutputBody> {
        const response = await this.replaceAccoladeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
